import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { axiosWCApiInstance } from '../../configuration/axios/axiosConfiguration';
import { appInsights } from '../../AppInsights';
import { ApiError } from '../../utils/ApiError';

const getInvoices = async (params) => {
    try {
        const response = await axiosWCApiInstance.get('invoicingListView', { params });
        return response.data;
    } catch (error) {
        console.log(`GetInvoices error=${error}`);
        appInsights.trackException({
            exception: error,
            properties: {
                method: 'getInvoices',
                severityLevel: SeverityLevel.Error,
            },
        });
        if (error.response?.data) {
            throw new ApiError(error.response.data);
        } else if (error.message) {
            throw new ApiError(error.message);
        } else {
            throw ApiError.UnwrappedError(
                'Server Error',
                'There was a problem processing that request.',
                'GetInvoices'
            );
        }
    }
};

const generateInvoices = async (data) => {
    try {
        const response = await axiosWCApiInstance.post('invoice/GenerateGeneralInvoices', data);
        return response.data;
    } catch (error) {
        console.log(`GenerateInvoices error=${error}`);
        appInsights.trackException({
            exception: error,
            properties: {
                method: 'generateInvoices',
                severityLevel: SeverityLevel.Error,
            },
        });
        if (error.response?.data) {
            throw new ApiError(error.response.data);
        } else if (error.message) {
            throw new ApiError(error.message);
        } else {
            throw ApiError.UnwrappedError(
                'Server Error',
                'There was a problem processing that request.',
                'GenerateInvoices'
            );
        }
    }
};
export { getInvoices, generateInvoices };
